import {useLocation} from '@github-ui/react-router'
import {useNavigate, useSearchParams} from '@github-ui/use-navigate'
import {Pagination} from '@primer/react'
import {useCallback} from 'react'

import {CONSTS} from './constants/values'

export const LabelListPagination = ({dataCount}: {dataCount: number}) => {
  const PAGE_SIZE = CONSTS.labelsPageSize
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()

  const currentPage = searchParams.get('page') ? parseInt(searchParams.get('page') as string, 10) : 1

  const handlePageChange = useCallback(
    (e: React.MouseEvent, page_number: number) => {
      e.preventDefault()
      if (page_number === currentPage) return
      const params = new URLSearchParams(searchParams)
      params.set('page', page_number.toString())

      const href = `${location.pathname}?${params.toString()}`
      navigate(href)
    },
    [navigate, searchParams, currentPage, location.pathname],
  )
  const hrefBuilder = useCallback(
    (page_number: number) => {
      const params = new URLSearchParams(searchParams)
      params.set('page', page_number.toString())
      return `${location.pathname}?${params.toString()}`
    },
    [searchParams, location.pathname],
  )

  return (
    <Pagination
      pageCount={Math.ceil(dataCount / PAGE_SIZE)}
      hrefBuilder={hrefBuilder}
      currentPage={currentPage}
      onPageChange={handlePageChange}
    />
  )
}
